:host {
  display: block;
}

.spw-header-lang {
  position: relative;
  @include under-breakpoint(lg) {
    margin: 12px 0;
  }
  &:hover {
    .spw-header-lang__dropdown {
      @include breakpoint(lg) {
        display: block;
      }
    }
  }

  &__active-lang {
    display: none;
    @include breakpoint(lg) {
      display: block;
    }
  }

  &__dropdown {
    display: flex;
    @include breakpoint(lg) {
      display: none;
      z-index: 99999;
      position: absolute;
      overflow: hidden;
      top: 100%;
      width: 100%;
      left: 0;
      background: white;
      border-radius: 4px;
      box-shadow: var(--spw-effect-elevation-8);
    }
  }
}
